define('v3/Pages/Check/Components/CheckPupilGrid/Services/checkPupilGrid.Backend',[
	'jquery',
	'module',
	'BackendBase'
], function ($, module, BackendBase) {
	function CheckPupilBackend () {
		BackendBase.call(this);
	};

	CheckPupilBackend.prototype = $.extend({}, BackendBase.prototype);

	$.extend(CheckPupilBackend.prototype, {

		getAbilityGrowthForSubjectGroups: function (pupilId, period, usePupilAverageGrowth) {
			if (usePupilAverageGrowth) {
				var url = Settings.metricsApi;
				return this._getJsonApiWithJwtAuthorization(url + '/Growth/' + pupilId + '/SubjectGroups', { period: period }, { showError: false });
			} else {
				return this._getJsonApi('SubjectGroupPupilAbilityGrowth/' + pupilId + '/Subjects', { period: period });
			}
		},

		getAllSubjectGroupsSubjectCurrentPercentilesForPupil: function (pupilId) {
			return this._getJsonApiWithJwtAuthorization(this._getApiUrl('Boundaries/SubjectGroupsSubjectCurrentPercentilesForPupil/' + pupilId));
		},

		getUserSubjectGroupTargetPercentiles: function (pupilId) {
			return this._getJsonApi('Boundaries/SubjectGroupTargetPercentilesForPupil/' + pupilId);
		},

		getSubdomainsBySubjectGroupWithBoundaryPercentileForPupil: function (subjectGroupId, pupilId) {
			return this._getJsonApiWithJwtAuthorization(this._getApiUrl('Subdomains/' + subjectGroupId + '/SubdomainsBySubjectGroupWithBoundaryPercentileForPupil/' + pupilId));
		},

		getSubdomainsBySubjectGroup: function (subjectGroupId) {
			return this._getJsonApiWithJwtAuthorization(this._getJsonApi('Subdomains/SubdomainsBySubjectGroup/' + subjectGroupId));
		},

		generateReport: function (html) {
			return this._postJsonApi('PupilsReport/GeneratePdf', { html: html });
		}
	});

	return new CheckPupilBackend();
});

